import { render, staticRenderFns } from "./ProfileCardRef.vue?vue&type=template&id=35db7f11&scoped=true"
import script from "./ProfileCardRef.vue?vue&type=script&lang=js"
export * from "./ProfileCardRef.vue?vue&type=script&lang=js"
import style0 from "./ProfileCardRef.vue?vue&type=style&index=0&id=35db7f11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35db7f11",
  null
  
)

export default component.exports